import { render, staticRenderFns } from "./SimuladorEmprestimoConsignado.vue?vue&type=template&id=5fb7d67b&scoped=true&"
import script from "./SimuladorEmprestimoConsignado.vue?vue&type=script&lang=js&"
export * from "./SimuladorEmprestimoConsignado.vue?vue&type=script&lang=js&"
import style0 from "./SimuladorEmprestimoConsignado.vue?vue&type=style&index=0&id=5fb7d67b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fb7d67b",
  null
  
)

export default component.exports